import { Injectable, signal } from '@angular/core';

export interface UnsavedWorkProvider {
  isDirty: () => boolean;
}

@Injectable({ providedIn: 'root' })
export class UnsavedWorkRegistry {
  private providers = new Set<UnsavedWorkProvider>();
  readonly hasUnsavedChanges = signal<boolean>(false);

  register(provider: UnsavedWorkProvider): () => void {
    this.providers.add(provider);
    this.updateState();
    return () => {
      this.providers.delete(provider);
      this.updateState();
    };
  }

  checkUnsaved(): boolean {
    for (const p of this.providers) {
      if (p.isDirty()) {
        return true;
      }
    }
    return false;
  }

  private updateState(): void {
    this.hasUnsavedChanges.set(this.checkUnsaved());
  }
}
